import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import useApi from "../../../utils/api";
import { getErrorMessage } from "../../../utils/helpers/errors";

export const useResetPasswordMutation = () => {
    const { t } = useTranslation();
    const { authPost } = useApi();

    return useMutation({
        mutationFn: (userId: string) => authPost(`/users/${userId}/reset-password`),
        onSuccess: () => toast.success(t("employee-password-reseted")),
        onError: (err: any) => getErrorMessage(err, t),
    });
};
